'use client';

import { Dialog, Drawer } from '@sprd/sprd-component-kit/v2';
import { ComponentProps, ReactNode, useEffect } from 'react';
import { useIsClient } from '@/hooks/useIsClient';
import { useIsDesktop } from '@/hooks/useMediaQuery';

type ResponsiveDialogProps = ComponentProps<typeof Dialog | typeof Drawer> & {
  title: ReactNode;
  ssr?: boolean;
  ariaLabel?: string;
};

export const ResponsiveDialog = (props: ResponsiveDialogProps) => {
  const { title, ariaLabel, ssr = false, children } = props;
  const isDesktop = useIsDesktop();
  const isClient = useIsClient();

  // workaround to make sure that pointer-events is always 'auto' when the dialog is closed
  // see also https://github.com/radix-ui/primitives/issues/2122 and https://github.com/radix-ui/primitives/issues/1241
  useEffect(() => {
    if (!props.open) {
      document.body.style.pointerEvents = 'auto';
    }
  }, [props.open]);

  if (!isClient && ssr) {
    return (
      <div role="dialog" aria-modal={true} aria-label={ariaLabel} className="sr-only">
        <div role="document">
          <h2>{title}</h2>
          <div>{children}</div>
        </div>
      </div>
    );
  }

  if (isDesktop) {
    return <Dialog {...props}>{children}</Dialog>;
  }
  return <Drawer {...props}>{children}</Drawer>;
};
